<div class="tile-area">
    <div>
        <div style="display: table">
            <div style="display: table-row; margin: auto; font-size: 50px; width: 100%; text-align: center; font-weight: bold;">
                {{this.generalInfo?.HomePageTitle}}
            </div>
            <div style="display: table-row">
                <div style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center; min-height: 120px; margin-bottom: 20px;">
                @if (multipleAccountsAvailable) {
                    <cp-tile-button color="white" [backgroundColor]="backgroundColor"
                            [hoverColor]="hoverColor" icon="switch_account" [width]="120"
                            [height]="120" (buttonClick)="gotoAccountSelector()">
                        {{this.generalInfo?.AccountSelectionTitle}}
                    </cp-tile-button>
                }
                @for (item of menuItems; track item) {
                    <cp-tile-button color="white" [backgroundColor]="backgroundColor"
                            [hoverColor]="hoverColor" [icon]="item.buttonIcon" [width]="120"
                            [height]="120" (buttonClick)="goto(item.route)"
                            [disabled]="!isAccountSelected" [disabledBackgroundColor]="disabledBackgroundColor">
                        {{item.buttonLabel}}
                    </cp-tile-button>
                }
            </div>
            <div style="height: 90px; background-color: #e6e6e6; width: 100%;">
                <table style="height: 90px;" width="100%">
                    <tr>
                        <td style="height: 90px;" rowspan="4">
                            <div style="position: relative; width: 90px; height: 90px;">
                                <mat-icon style="color: rgba(99, 99, 99, 0.3); height: 80px; line-height: 80px; width: 80px; font-size: 80px; position: absolute; bottom: 0; left: 0;">factory</mat-icon>
                            </div>
                        </td>
                        <td style="width: 100%">
                            <div style="display: inline-block; color: #999999;">
                                <cp-account-display></cp-account-display>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div style="display: flex; margin-top: 20px; gap: 10px;">
                <div style="width: 50%;">
                    <cp-account-users></cp-account-users>
                </div>
                <div style="width: 50%;">
                    <cp-account-reps></cp-account-reps>
                </div>
            </div>
        </div>
    </div>
</div>
